import {
    BrandsFactory,
    FormsFactory,
    GenericWrapperContext,
    getBrandUrl,
    getNestedProperty,
    Icon,
    LoadingContainer,
    TBrand,
    Typography
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { logError } from "../../../utils/data"
import { ELogErrorMsg } from "../../../utils/data/types"
import { getCurrentPathParams } from "../../../utils/url"
import "./styles.scss"

export function PublicForm() {
    const genericWrapper = useContext(GenericWrapperContext)

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [userBrand, setUserBrand] = useState<TBrand | undefined>(genericWrapper?.userBrand || undefined)
    const [formHtml, setFormHtml] = useState<string | undefined>(undefined)

    const { t } = useTranslation()
    const location = useLocation()

    // Look at the function comment to know why useParams was not used
    const { params } = getCurrentPathParams()
    const token = params.token

    const queryParams = new URLSearchParams(location.search)

    const accountId = queryParams.get('a')

    useEffect(() => {
        if (token) {
            fetchFormHtml(token)
        }
        if (!userBrand && accountId) {
            fetchUserBrand(accountId)
        }
    }, [])

    function fetchFormHtml(token: string) {
        FormsFactory.renderPublic({ token: token })
            .then((html: string) => {
                setFormHtml(html)
            }).catch((error) => {
                setError(true)
                logError(ELogErrorMsg.ErrorGettingForm, error)
            }).finally(() => {
                setLoading(false)
            })
    }

    function fetchUserBrand(accountId: string) {
        BrandsFactory.get({ id: accountId })
            .then((brand) => {
                setUserBrand(brand)
            })
            .catch((error) => {
                return null
            })
    }

    const insertLogo = userBrand ? getNestedProperty(userBrand, "insert_reseller_logo") : false
    const footerLogo = getBrandUrl({ elKey: "injected_logo", brand: genericWrapper.partnerBrand })

    return <Stack className="publicFormPage" flex={1} justifyContent="space-between">
        <LoadingContainer loading={loading} showChildren>
            <Stack id="form-container" alignItems="center" justifyContent="flex-start" width="100%" flex={1} paddingTop={4}>
                {formHtml && formHtml.length > 0 && <div dangerouslySetInnerHTML={{ __html: formHtml }} />}
                {error && <Stack className="error" alignItems="center" justifyContent="center" gap={8}>
                    <Typography variant="h3L">{t("forms-public-error-title")}</Typography>
                    <Icon name="EmptyFolder44" />
                    <Typography variant="body1L" className="semibold">{t("forms-public-error-desc")}</Typography>
                </Stack>}
            </Stack>
            {userBrand && footerLogo && <Stack
                gap={2}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                className="footerLogo"
            >
                <Typography variant="body1" color="white.main">{t("general-powered-by-txt")}</Typography>
                <img src={insertLogo || footerLogo} alt={userBrand.name} />
            </Stack>}
        </LoadingContainer>
    </Stack>


}

export default PublicForm